<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'PopconfirmBtn',
})
</script>
<template>
  <Popconfirm v-bind="$attrs">
    <Button v-bind="btnProps">
      <slot />
    </Button>
  </Popconfirm>
</template>

<script lang="ts" setup name="PopconfirmBtn">
import { Button, Popconfirm, type ButtonProps } from 'ant-design-vue'
import type { PropType } from 'vue'
defineProps({
  btnProps: {
    type: Object as PropType<ButtonProps>,
    default: () => ({})
  }
})
</script>
